import { render } from "./MockPortfolio.vue?vue&type=template&id=e9de7452&scoped=true"
import script from "./MockPortfolio.vue?vue&type=script&lang=js"
export * from "./MockPortfolio.vue?vue&type=script&lang=js"

import "./MockPortfolio.vue?vue&type=style&index=0&id=e9de7452&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9de7452"]])

export default __exports__